import { useTrackPage, removeProfileCookie } from 'utils/analytics'
import dynamic from 'next/dynamic'
import { useDatadog } from 'utils/datadog'
import { useBot } from 'hooks/useBot'

const Tealium = dynamic(() => import('components/Tealium').then((mod) => mod.Tealium), {
  ssr: false,
})

function Analytics({ children, pageVariation, pageSectionsVariations, loadEventProps, siteEnv }) {
  removeProfileCookie()

  useDatadog()

  useTrackPage(pageVariation, pageSectionsVariations, loadEventProps, siteEnv)

  const { isBot } = useBot()

  return (
    <>
      {!isBot ? <Tealium /> : null}
      {children}
    </>
  )
}

export { Analytics }
